import ZlbConfirm from '@/components/ZlbConfirm';
import { requestInstitution, getExpenseExport, getExportFileId } from '../services';

const responseErrorHandle = (res) => {
  const { success, message, statusText } = res;
  if (!success) {
    ZlbConfirm({
      title: message || statusText,
      showOkBtn: false,
      cancelText: '知道了',
    });
  }
  return success;
};

const formatTree = (tree) => {
  if (tree.length) {
    tree?.forEach((item) => {
      item.label = item.name;
      item.value = item.code;
      if (item.children) formatTree(item.children);
    });
  }
};

export default {
  namespace: 'financeInvoiceData',
  state: {
    tree: [],
    orgList: [],
  },
  effects: {
    * getInstitution ({ payload }, { call, put }) {
      const res = yield call(requestInstitution, payload);
      responseErrorHandle(res);
      yield put({
        type: 'update',
        payload: {
          orgList: res.result,
        },
      });
    },
    
    * getExpenseExport ({ payload }, { call }) {
      const res = yield call(getExpenseExport, payload);
      return res;
    },

    * getExportFileId ({ payload }, { call }) {
      const res = yield call(getExportFileId, payload);
      return res;
    },
  },
  reducers: {
    update (state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
